__turbopack_context__.v({
  "className": "-xJMmW_className",
  "variable": "-xJMmW_variable",
});
